export default (data = {}) => ({
  patient: {
    id: null,
    type: null
  },
  price_start: null,
  price_end: null,
  covenant_id: null,
  location: {
    id: null,
    distance: null
  },
  covenants: {},
  schedules: {},
  page: 1,
  limit: 5,
  ...data})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/dataFilter.js